export default {
  name: 'Light',
  light: true,
  dark: false,
  grid: {
    container: '100%',
    gutter: '2rem', // 32px
  },
  border: {
    radius: {
      xsmall: '13px',
      small: '18px',
      medium: '24px',
      large: '30px',
      xlarge: '32px',
    },
  },
  font: {
    quicksand:
      "Quicksand, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    nunito:
      "Nunito, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    sizes: {
      xxsmall: '0.625rem', // 10px
      xsmall: '0.75rem', // 12px
      small: '0.875rem', // 14px
      medium: '1rem', // 16px
      large: '1.25rem', // 20px
      xlarge: '1.75rem', // 28px
      xxlarge: '2rem', // 32px
    },
  },
  colors: {
    primary: '#ff4c4c',
    primaryText: '#FFFFFF',
    secondary: '#433d3d',
    secondaryBg: '#FFFFFF',
    body: '#433d3d',
    mainBg: '#f6f6f6',
    borderColor: '#c5c0c0',
    superLight: '#8e8b8b',
    secondaryButtonBg: '#FFFFFF',
    buttonShadowColor: 'rgba(191, 206, 236, 0.6)',

    white: '#ffffff',
    black: '#433d3d',
    lightGray: '#c5c0c0',
    gray: '#8e8b8b',
    supportSuperLight: '#D9D9D9',
    supportDarker: '#2E2A2A',
    supportGray: '#5e565a',
    red: '#f34040',
    green: '#43cb8f',
    loadingGradient: 'rgba(237,237,237,1)',
    secondaryYellow: '#FBA240',
  },
  spacings: {
    xxsmall: '0.75rem', // 12px
    xsmall: '1rem', // 16px
    small: '1.5rem', // 24px
    medium: '1.75rem', // 28px
    large: '2rem', // 32px
    xlarge: '2.125rem', // 34px
    xxlarge: '2.375rem', // 38px
  },
  layers: {
    base: 10,
    menu: 20,
    overlay: 30,
    modal: 40,
    alwaysOnTop: 50,
  },
  transition: {
    default: '0.3s ease-in-out',
    fast: '0.1s ease-in-out',
  },
} as const
